import PlayerCard from './PlayerCard';
import PlayerCardActions from './PlayerCardActions';
import PlayerCardContent from './PlayerCardContent';
import VideoPlayer from '../VideoPlayer/VideoPlayer';

PlayerCard.Actions = PlayerCardActions;
PlayerCard.Content = PlayerCardContent;
PlayerCard.Video = VideoPlayer;

export default PlayerCard;
